import { Video, onStage, pictureInPicture, room, spacesView } from "../../../libs/roomnew";
import { getPerformanceState } from "../performance-optimizer/functions";
import { QUALITY_RULES, RESOLUTION } from "./constants";
import { getAppState } from "./electron";
import { emitVisibleEndpointsChanged } from "./eventDispatcher";

const VISIBLE_ENDPOINTS={
    mainScreen:[],
    spacesView:[],
    spacesLobbyView:[],
    myStageView:[],
    spaceMenu:[],
    spacesManager:[],
    spacesManagerLobby:[],
};

const FORWARDED_ENDPOINTS={
    mainScreen:[],
    strip:[],
    spacesView:[],
    presenter:[],
    myStage:[],
    spaceMenu:[],
    spacesManager:[],
};

const FORWARDED_RESOLUTIONS={
    mainScreen:{maxHeight:0,maxFrameRate:0},
    strip:{maxHeight:RESOLUTION.LOW,maxFrameRate:0},
    spacesView:{maxHeight:RESOLUTION.LOW,maxFrameRate:0},
    spaceMenu:{maxHeight:RESOLUTION.LOW,maxFrameRate:0},
    presenter:{maxHeight:RESOLUTION.HIGH,maxFrameRate:0},
    myStage:{maxHeight:RESOLUTION.MEDIUM,maxFrameRate:0},
    spacesManager:{maxHeight:RESOLUTION.LOW,maxFrameRate:0},
};

let CURRENT_MAX_RESOLUTION=QUALITY_RULES.MAIN_SCREEN_RESOLUTION;

export const isEndpointVisible=(eid)=>{
    if(VISIBLE_ENDPOINTS.mainScreen.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.spacesView.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.spacesLobbyView.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.myStageView.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.spaceMenu.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.spacesManager.includes(eid)) {return true}
    if(VISIBLE_ENDPOINTS.spacesManagerLobby.includes(eid)) {return true}
    return false
}

export const getScreenVisibleParticipants=()=>{
    let presenterEndpoints=[];
    let mainScreenEndpoints=[];
    let stripEndpoints=[];
    let spacesViewEndpoints=[];
    let myStage=[];
    let spaceMenu=[];
    let spacesManager=[];
    const firstLoadEndpoints=[];

    for (const eid in Video.videos) {
        if(Video.videos[eid].skipEfss){
            firstLoadEndpoints.push(eid);
        }
    }

    if(Video.presenter.isPresenterView && Video.presenter.getPresenterId()){
        presenterEndpoints.push(Video.presenter.getPresenterId())
    }

    if(onStage.isActive() && onStage.myStage.isStageView()){
        try {
            myStage=onStage.participants.filter(pid=>pid!=room.myUserId());
        } catch (error) { console.error("[Kino Error] [functions]", error); }
    }

    const mainScreenParticipants=Object.keys(Video.mainParticipants);
    mainScreenEndpoints=mainScreenParticipants.filter(id=>VISIBLE_ENDPOINTS.mainScreen.includes(id) && !presenterEndpoints.includes(id) && !myStage.includes(id))

    const sideScreenParticipants=Object.keys(Video.sideParticipants);
    stripEndpoints=sideScreenParticipants.filter(id=>VISIBLE_ENDPOINTS.mainScreen.includes(id) && !presenterEndpoints.includes(id) && !mainScreenEndpoints.includes(id))
    stripEndpoints=[...new Set([...stripEndpoints,...firstLoadEndpoints])];
    // spacesViewEndpoints = kinoParticipants.getParticipants().map(p=>p.id);
    spacesViewEndpoints=[...new Set([...VISIBLE_ENDPOINTS.spacesView,...VISIBLE_ENDPOINTS.spacesLobbyView])];
    spaceMenu=[...new Set([...VISIBLE_ENDPOINTS.spaceMenu])];

    //spaces manager endpoints
    if(Video.splitConversations.isManualSplitVisible()){
        spacesManager=[...new Set([...VISIBLE_ENDPOINTS.spacesManager,...VISIBLE_ENDPOINTS.spacesManagerLobby])];
    }

    return {
        mainScreen: mainScreenEndpoints,
        strip: stripEndpoints,
        spacesView: spacesViewEndpoints,
        presenter: presenterEndpoints,
        myStage: myStage,
        spaceMenu: spaceMenu,
        spacesManager: spacesManager,
    };
};

export const showCameraLayerWhenAppMinimized=(pid)=>{
    if(getAppState()==='background' && !Video.isForwarded(pid)){
        return false
    }
    return true
}

export const getResolutionPerScreen=(screens)=>{
    const currentMaxResolution=getCurrentMaxResolution();
    const {maxFrameRate}=getPerformanceState();
    let videoHeight = Video.remoteVideosContainer.find(".videoViewContainer:first").height();
    const maxResolution=Math.min(currentMaxResolution,QUALITY_RULES.MAIN_SCREEN_RESOLUTION);
    let idealResolution=maxResolution;
    let mainScreenResolution=idealResolution;
    if(spacesView.isOpen() || Video.splitConversations.isManualSplitVisible()){
        idealResolution=RESOLUTION.LOW;
    }else if(screens.presenter.length){
        idealResolution=RESOLUTION.LOW;
    }else if(pictureInPicture.isPIP()){
        if(screens.mainScreen.length >= 10){
            idealResolution=RESOLUTION.LOW;
        }else{
            idealResolution=Math.min(RESOLUTION.MEDIUM,maxResolution);
        }
    }
    if (videoHeight > QUALITY_RULES.HIGH_RES_VIDEO_HEIGHT) {
        mainScreenResolution = Math.min(idealResolution,screens.mainScreen.length >= QUALITY_RULES.MAX_SELECTED ? RESOLUTION.MEDIUM : RESOLUTION.HIGH);
    } else if (videoHeight <= QUALITY_RULES.HIGH_RES_VIDEO_HEIGHT && videoHeight > 180) {
        mainScreenResolution = Math.min(RESOLUTION.MEDIUM,idealResolution);
    } else if (videoHeight <= 180) {
        mainScreenResolution = Math.min(RESOLUTION.LOW,idealResolution);
    }


    return {
        mainScreen: {maxHeight:mainScreenResolution,maxFrameRate:Math.max(maxFrameRate,10)},
        strip: {maxHeight:RESOLUTION.LOW,maxFrameRate:5},
        spacesView: {maxHeight:RESOLUTION.LOW,maxFrameRate:5},
        spaceMenu: {maxHeight:RESOLUTION.LOW,maxFrameRate:5},
        presenter: {maxHeight:RESOLUTION.HIGH,maxFrameRate:Math.max(maxFrameRate,10)},
        myStage: {maxHeight:Math.min(RESOLUTION.MEDIUM,maxResolution),maxFrameRate:maxFrameRate},
        spacesManager: {maxHeight:RESOLUTION.LOW,maxFrameRate:5},
    }
}

export const setCurrentMaxResolution=(resolution)=>{
    CURRENT_MAX_RESOLUTION = resolution;
}
export const getCurrentMaxResolution=()=>{
    return CURRENT_MAX_RESOLUTION;
}

export const setForwardedEndpoints=(forwarded)=>{
    FORWARDED_ENDPOINTS.mainScreen=forwarded.mainScreen;
    FORWARDED_ENDPOINTS.strip=forwarded.strip;
    FORWARDED_ENDPOINTS.spacesView=forwarded.spacesView;
    FORWARDED_ENDPOINTS.presenter=forwarded.presenter;
    FORWARDED_ENDPOINTS.myStage=forwarded.myStage;
    FORWARDED_ENDPOINTS.spaceMenu=forwarded.spaceMenu;
    FORWARDED_ENDPOINTS.spacesManager=forwarded.spacesManager;
}

export const getForwardedEndpoints=()=>{
    return {...FORWARDED_ENDPOINTS};
}

export const setForwardedResolutions=(forwarded)=>{
    FORWARDED_RESOLUTIONS.mainScreen=forwarded.mainScreen;
    FORWARDED_RESOLUTIONS.strip=forwarded.strip;
    FORWARDED_RESOLUTIONS.spacesView=forwarded.spacesView;
    FORWARDED_RESOLUTIONS.presenter=forwarded.presenter;
    FORWARDED_RESOLUTIONS.myStage=forwarded.myStage;
    FORWARDED_RESOLUTIONS.spaceMenu=forwarded.spaceMenu;
    FORWARDED_RESOLUTIONS.spacesManager=forwarded.spacesManager;
}

export const getForwardedResolutions=()=>{
    return {...FORWARDED_RESOLUTIONS};
}

export const setMainScreenVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    // console.error("Set main screen visible endpoints",endpoints)
    const oldEndpoints=VISIBLE_ENDPOINTS.mainScreen;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.mainScreen=endpoints;
        emitVisibleEndpointsChanged('mainScreen',oldEndpoints,endpoints)
        return
    }
}

export const getMainScreenVisibleEndpoints=()=>{
    return [...VISIBLE_ENDPOINTS.mainScreen]
}


export const setSpacesViewVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    const oldEndpoints=VISIBLE_ENDPOINTS.spacesView;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.spacesView=endpoints;
        emitVisibleEndpointsChanged('spacesView',oldEndpoints,endpoints)
        return
    }
}
export const setSpaceMenuVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    const oldEndpoints=VISIBLE_ENDPOINTS.spaceMenu;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.spaceMenu=endpoints;
        emitVisibleEndpointsChanged('spaceMenu',oldEndpoints,endpoints)
        return
    }
}

export const setSpacesManagerVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    const oldEndpoints=VISIBLE_ENDPOINTS.spacesManager;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.spacesManager=endpoints;
        emitVisibleEndpointsChanged('spacesManager',oldEndpoints,endpoints)
        return
    }
}

export const setSpacesManagerLobbyVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    const oldEndpoints=VISIBLE_ENDPOINTS.spacesManagerLobby;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.spacesManagerLobby=endpoints;
        emitVisibleEndpointsChanged('spacesManagerLobby',oldEndpoints,endpoints)
        return
    }
}

export const getSpacesViewVisibleEndpoints=()=>{
    return [...VISIBLE_ENDPOINTS.spacesView]
}

export const setSpacesLobbyViewVisibleEndpoints = (endpoints,forceUpdate=false)=>{
    const oldEndpoints=VISIBLE_ENDPOINTS.spacesLobbyView;
    if(endpointArrayChanged(oldEndpoints,endpoints) || forceUpdate){
        VISIBLE_ENDPOINTS.spacesLobbyView=endpoints;
        emitVisibleEndpointsChanged('spacesLobbyView',oldEndpoints,endpoints)
        return
    }
}

export const getSpacesLobbyViewVisibleEndpoints=()=>{
    return [...VISIBLE_ENDPOINTS.spacesLobbyView]
}

export const hasForwardedEndpointsChanged=(oldObject,newObject)=>{
    if(
        (oldObject.mainScreen.length != newObject.mainScreen.length)
        || (oldObject.strip.length != newObject.strip.length)
        || (oldObject.spacesView.length != newObject.spacesView.length)
        || (oldObject.presenter.length != newObject.presenter.length)
        || (oldObject.myStage.length != newObject.myStage.length)
        || (oldObject.spaceMenu.length != newObject.spaceMenu.length)
        || (oldObject.spacesManager.length != newObject.spacesManager.length)
        ){
            return true;
        }
    if(
        (oldObject.mainScreen.sort().join("") != newObject.mainScreen.sort().join(""))
        || (oldObject.strip.sort().join("") != newObject.strip.sort().join(""))
        || (oldObject.spacesView.sort().join("") != newObject.spacesView.sort().join(""))
        || (oldObject.presenter.sort().join("") != newObject.presenter.sort().join(""))
        || (oldObject.myStage.sort().join("") != newObject.myStage.sort().join(""))
        || (oldObject.spaceMenu.sort().join("") != newObject.spaceMenu.sort().join(""))
        || (oldObject.spacesManager.sort().join("") != newObject.spacesManager.sort().join(""))
        ){
            return true;
        }
    return false
}

export const hasForwardedResolutionChanged=(oldObject,newObject)=>{
    if(oldObject.mainScreen != newObject.mainScreen){
        return true;
    }
    return false
}

export const endpointArrayChanged = (oldArray,newArray)=>{
    if(oldArray.length != newArray.length){
        return true
    }
    console.log(`Comparing arrays [${oldArray.sort().join("")}==${newArray.sort().join("")}]`)
    if(oldArray.sort().join("") != newArray.sort().join("")){
        return true
    }
    return false
}
